var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlasses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.66667 8.9456C8.69461 8.35147 9.97195 8.35147 10.9999 8.9456M1 9.33333L1.58457 3.48759C1.60674 3.26596 1.61782 3.15514 1.63481 3.06007C1.83519 1.93918 2.76767 1.0953 3.90293 1.00745C3.99922 1 4.11059 1 4.33333 1M17.6667 9.33333L17.0821 3.48759C17.0599 3.26596 17.0488 3.15514 17.0319 3.06007C16.8315 1.93918 15.899 1.0953 14.7637 1.00745C14.6674 1 14.5561 1 14.3333 1M6.69036 6.97631C7.9921 8.27805 7.9921 10.3886 6.69036 11.6904C5.38861 12.9921 3.27806 12.9921 1.97631 11.6904C0.674564 10.3886 0.674564 8.27806 1.97631 6.97631C3.27805 5.67456 5.38861 5.67456 6.69036 6.97631ZM16.6904 6.97631C17.9921 8.27805 17.9921 10.3886 16.6904 11.6904C15.3886 12.9921 13.2781 12.9921 11.9763 11.6904C10.6746 10.3886 10.6746 8.27806 11.9763 6.97631C13.2781 5.67456 15.3886 5.67456 16.6904 6.97631Z",
    stroke: "var(--stroke-0, #9F9F9F)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasses);
export default __webpack_public_path__ + "static/media/glasses.01e6eb76cbe7c02a6b1e1ac5bd21c87c.svg";
export { ForwardRef as ReactComponent };